export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ffd6b0f684beb1c6800be81f3fbffc05a135c83e9&name=fetchTypeahead!'